// extracted by mini-css-extract-plugin
module.exports = {"block":"_11705","content":"_7074","name":"_4634","large":"_8292","distance":"_1722","actions":"_16227","item":"_9946","icon":"_3636","label":"_15368","divider":"_4850"};